import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "charts"
    }}>{`Charts`}</h1>
    <p>{`To dynamically insert a chart in the document, add the chart as placeholder and edit the chart and excel data.`}</p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How It Works`}</h2>
    <p>{`To insert a chart in the document, add the chart as a placeholder in the document template. The chart placeholder is transformed into a chart in the output document by providing the chart data in the input JSON data.
The following types of graphs are supported:`}</p>
    <ul>
      <li parentName="ul">{`Line`}</li>
      <li parentName="ul">{`Column`}</li>
      <li parentName="ul">{`Pie`}</li>
    </ul>
    <p>{`Steps to add chart in the document:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Open your Word document`}</strong>{` and place the cursor where you want the chart to appear.`}</li>
      <li parentName="ul"><strong parentName="li">{`Go to the “Insert” tab`}</strong>{` on the Ribbon.`}</li>
      <li parentName="ul"><strong parentName="li">{`Click on “Chart”`}</strong>{` in the Illustrations group.`}</li>
      <li parentName="ul"><strong parentName="li">{`Choose the type of chart`}</strong>{` you want from the list (e.g. column, line, pie) and click “OK”.`}</li>
      <li parentName="ul">{`An `}<strong parentName="li">{`Excel spreadsheet`}</strong>{` will open with sample data. Replace this data with your own tags.`}</li>
      <li parentName="ul"><strong parentName="li">{`Close the Excel`}</strong>{` window once you’ve entered your data. The chart in Word will update automatically.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/5530d/insert_chart_in_document.webp 320w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/0c8fb/insert_chart_in_document.webp 640w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/94b1e/insert_chart_in_document.webp 1280w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/5e94d/insert_chart_in_document.webp 1386w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/dd4a7/insert_chart_in_document.png 320w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/0f09e/insert_chart_in_document.png 640w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/bbbf7/insert_chart_in_document.png 1280w", "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/7daeb/insert_chart_in_document.png 1386w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/0e8134083f317ef0ca846cdff24a6510/bbbf7/insert_chart_in_document.png",
            "alt": "Edit chart data in Excel",
            "title": "Edit chart data in Excel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Include only the chart data in the Excel sheet, omitting any additional text.`}</p>
    <h2 {...{
      "id": "line-chart"
    }}>{`Line Chart`}</h2>
    <p><strong parentName="p">{`Steps to insert a line chart in the document:`}</strong></p>
    <ul>
      <li parentName="ul">{`Add the line chart as a placeholder in the document template.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "606px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/27771048c96374a4ea53a44b656f7e0b/5530d/line_chart_placeholder.webp 320w", "/document-services/docs/static/27771048c96374a4ea53a44b656f7e0b/e5c51/line_chart_placeholder.webp 606w"],
            "sizes": "(max-width: 606px) 100vw, 606px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/27771048c96374a4ea53a44b656f7e0b/dd4a7/line_chart_placeholder.png 320w", "/document-services/docs/static/27771048c96374a4ea53a44b656f7e0b/cec09/line_chart_placeholder.png 606w"],
            "sizes": "(max-width: 606px) 100vw, 606px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/27771048c96374a4ea53a44b656f7e0b/cec09/line_chart_placeholder.png",
            "alt": "Placeholder for line chart",
            "title": "Placeholder for line chart",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul">{`Edit the chart data in the Excel by right click on chart and select "Edit Data in Excel".`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "531px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "38.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c4cba466823aab17aaac60b8730d9c4c/5530d/excel_line_chart.webp 320w", "/document-services/docs/static/c4cba466823aab17aaac60b8730d9c4c/61f13/excel_line_chart.webp 531w"],
            "sizes": "(max-width: 531px) 100vw, 531px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/c4cba466823aab17aaac60b8730d9c4c/dd4a7/excel_line_chart.png 320w", "/document-services/docs/static/c4cba466823aab17aaac60b8730d9c4c/b2c14/excel_line_chart.png 531w"],
            "sizes": "(max-width: 531px) 100vw, 531px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/c4cba466823aab17aaac60b8730d9c4c/b2c14/excel_line_chart.png",
            "alt": "Edit chart data in Excel",
            "title": "Edit chart data in Excel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`JSON representation of the input data:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Title": "Sales Data",
  "sales": [
    {
      "quarter": "Q1",
      "phone": 3800,
      "tablet": 2450
    },
    {
      "quarter": "Q2",
      "phone": 4300,
      "tablet": 2700
    },
    {
      "quarter": "Q3",
      "phone": 5100,
      "tablet": 3150
    },
    {
      "quarter": "Q4",
      "phone": 6000,
      "tablet": 3600
    }
  ]
}
`}</code></pre>
    <p><strong parentName="p">{`Output chart in document after processing.`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "605px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.06250000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9807295548a5032daeef2dbf509f10a7/5530d/output_line_chart.webp 320w", "/document-services/docs/static/9807295548a5032daeef2dbf509f10a7/4aa2d/output_line_chart.webp 605w"],
            "sizes": "(max-width: 605px) 100vw, 605px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9807295548a5032daeef2dbf509f10a7/dd4a7/output_line_chart.png 320w", "/document-services/docs/static/9807295548a5032daeef2dbf509f10a7/21793/output_line_chart.png 605w"],
            "sizes": "(max-width: 605px) 100vw, 605px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9807295548a5032daeef2dbf509f10a7/21793/output_line_chart.png",
            "alt": "Output of line chart in document",
            "title": "Output of line chart in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "column-chart"
    }}>{`Column Chart`}</h2>
    <p><strong parentName="p">{`Steps to insert a column chart in the document:`}</strong></p>
    <ul>
      <li parentName="ul">{`Add the column chart as a placeholder in the document template.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "604px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/645531d819fde8f8c2b7b1bad3f2d920/5530d/column_chart_placeholder.webp 320w", "/document-services/docs/static/645531d819fde8f8c2b7b1bad3f2d920/88e19/column_chart_placeholder.webp 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/645531d819fde8f8c2b7b1bad3f2d920/dd4a7/column_chart_placeholder.png 320w", "/document-services/docs/static/645531d819fde8f8c2b7b1bad3f2d920/1994c/column_chart_placeholder.png 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/645531d819fde8f8c2b7b1bad3f2d920/1994c/column_chart_placeholder.png",
            "alt": "Placeholder for column chart",
            "title": "Placeholder for column chart",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul">{`Edit the chart data in the Excel by right click on chart and select "Edit Data in Excel".`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "457px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/17430531709ca2ce196b01cfe55e02eb/5530d/excel_column_chart.webp 320w", "/document-services/docs/static/17430531709ca2ce196b01cfe55e02eb/59208/excel_column_chart.webp 457w"],
            "sizes": "(max-width: 457px) 100vw, 457px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/17430531709ca2ce196b01cfe55e02eb/dd4a7/excel_column_chart.png 320w", "/document-services/docs/static/17430531709ca2ce196b01cfe55e02eb/4c61e/excel_column_chart.png 457w"],
            "sizes": "(max-width: 457px) 100vw, 457px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/17430531709ca2ce196b01cfe55e02eb/4c61e/excel_column_chart.png",
            "alt": "Edit chart data in Excel",
            "title": "Edit chart data in Excel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`JSON representation of the input data:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Title": "Vehicle Sales Data",
  "sales": [
    {
      "month": "July",
      "EV": 700000,
      "ICE": 1500000
    },
    {
      "month": "August",
      "EV": 750000,
      "ICE": 1450000
    },
    {
      "month": "September",
      "EV": 800000,
      "ICE": 1400000
    },
    {
      "month": "October",
      "EV": 850000,
      "ICE": 1350000
    }
  ]
}

`}</code></pre>
    <p><strong parentName="p">{`Output chart in document after processing.`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "604px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/e9efb154824d72c6bd93e19c0f008ade/5530d/output_column_chart.webp 320w", "/document-services/docs/static/e9efb154824d72c6bd93e19c0f008ade/88e19/output_column_chart.webp 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/e9efb154824d72c6bd93e19c0f008ade/dd4a7/output_column_chart.png 320w", "/document-services/docs/static/e9efb154824d72c6bd93e19c0f008ade/1994c/output_column_chart.png 604w"],
            "sizes": "(max-width: 604px) 100vw, 604px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/e9efb154824d72c6bd93e19c0f008ade/1994c/output_column_chart.png",
            "alt": "Output of line chart in document",
            "title": "Output of line chart in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "pie-chart"
    }}>{`Pie Chart`}</h2>
    <p><strong parentName="p">{`Steps to insert a pie chart in the document:`}</strong></p>
    <ul>
      <li parentName="ul">{`Add the pie chart as a placeholder in the document template.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "611px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f806c192d1354fcbed7ebc3b972f2722/5530d/pie_chart_placeholder.webp 320w", "/document-services/docs/static/f806c192d1354fcbed7ebc3b972f2722/8dd45/pie_chart_placeholder.webp 611w"],
            "sizes": "(max-width: 611px) 100vw, 611px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f806c192d1354fcbed7ebc3b972f2722/dd4a7/pie_chart_placeholder.png 320w", "/document-services/docs/static/f806c192d1354fcbed7ebc3b972f2722/a91ec/pie_chart_placeholder.png 611w"],
            "sizes": "(max-width: 611px) 100vw, 611px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/f806c192d1354fcbed7ebc3b972f2722/a91ec/pie_chart_placeholder.png",
            "alt": "Placeholder for pie chart",
            "title": "Placeholder for pie chart",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul">{`Edit the chart data in the Excel by right click on chart and select "Edit Data in Excel".`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "407px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "46.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a17157bdf4f124ef852ef22b1994a168/5530d/excel_pie_chart.webp 320w", "/document-services/docs/static/a17157bdf4f124ef852ef22b1994a168/6c44f/excel_pie_chart.webp 407w"],
            "sizes": "(max-width: 407px) 100vw, 407px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a17157bdf4f124ef852ef22b1994a168/dd4a7/excel_pie_chart.png 320w", "/document-services/docs/static/a17157bdf4f124ef852ef22b1994a168/fc7bc/excel_pie_chart.png 407w"],
            "sizes": "(max-width: 407px) 100vw, 407px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a17157bdf4f124ef852ef22b1994a168/fc7bc/excel_pie_chart.png",
            "alt": "Edit chart data in Excel",
            "title": "Edit chart data in Excel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`JSON representation of the input data:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Title": "Car Sales by Quarters",
  "carSales": [
    {
      "quarter": "1st Qtr",
      "value": 1500
    },
    {
      "quarter": "2nd Qtr",
      "value": 2000
    },
    {
      "quarter": "3rd Qtr",
      "value": 1800
    },
    {
      "quarter": "4th Qtr",
      "value": 2200
    }
  ]
}
`}</code></pre>
    <p><strong parentName="p">{`Output chart in document after processing.`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "605px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f48ebdec2494f9c833744b0d97a8d2b5/5530d/output_pie_chart.webp 320w", "/document-services/docs/static/f48ebdec2494f9c833744b0d97a8d2b5/4aa2d/output_pie_chart.webp 605w"],
            "sizes": "(max-width: 605px) 100vw, 605px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/f48ebdec2494f9c833744b0d97a8d2b5/dd4a7/output_pie_chart.png 320w", "/document-services/docs/static/f48ebdec2494f9c833744b0d97a8d2b5/21793/output_pie_chart.png 605w"],
            "sizes": "(max-width: 605px) 100vw, 605px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/f48ebdec2494f9c833744b0d97a8d2b5/21793/output_pie_chart.png",
            "alt": "Output of pie chart in document",
            "title": "Output of pie chart in document",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <ul>
      <li parentName="ul">{`Do not use charts within repeating section tags.`}</li>
      <li parentName="ul">{`Ensure that the chart data in Excel starts from the first cell (A1).`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      